var map = {
	"./Pagina 0.jpg": 8655,
	"./Pagina 1.jpg": 4426,
	"./Pagina 10.jpg": 6481,
	"./Pagina 11.jpg": 3442,
	"./Pagina 12.jpg": 2850,
	"./Pagina 13.jpg": 9675,
	"./Pagina 14.jpg": 4607,
	"./Pagina 2.jpg": 5176,
	"./Pagina 3.jpg": 1678,
	"./Pagina 4.jpg": 5032,
	"./Pagina 5.jpg": 122,
	"./Pagina 6.jpg": 3772,
	"./Pagina 7.jpg": 8728,
	"./Pagina 8.jpg": 5449,
	"./Pagina 9.jpg": 5441
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2674;